import { render, staticRenderFns } from "./feriado.vue?vue&type=template&id=5d905c5a&"
import script from "./feriado.vue?vue&type=script&lang=js&"
export * from "./feriado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports